//@ts-check
import React from 'react';
import { StatusManage } from '../StatusManage';
import { StatusManageProvider, withStatusManageConsumer } from './StatusManageProvider';
import { StatusType } from '../helpers/statusConstants';

const WorkflowStatusManageWrapper = (props) => {
    return (
        <StatusManageProvider statusType={StatusType.file} >
            <StatusManageWithConsumer {...props} ></StatusManageWithConsumer>
        </StatusManageProvider>
    );
};

const StatusManageWithConsumer = withStatusManageConsumer(StatusManage);

export { WorkflowStatusManageWrapper };
